import { Component } from '@angular/core';

@Component({
  selector: 'app-dummy-component',
  imports: [],
  templateUrl: './dummy-component.component.html',
  styleUrl: './dummy-component.component.scss'
})
export class DummyComponentComponent {

}
